import { render, staticRenderFns } from "./smsNumSetting.vue?vue&type=template&id=ef73b17c&"
import script from "./smsNumSetting.vue?vue&type=script&lang=js&"
export * from "./smsNumSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports